const ArmorUse = require('../ability_trees/ArmorUse.js');
const Illusion = require('../ability_trees/Illusion.js');
const Spirit = require('../ability_trees/Spirit.js');
const StandardAbilityTree = require('../ability_trees/StandardAbilityTree.js');

const ItemGenerator = require('../../game_items/ItemGenerator.js');
const HeavyHelmet = require('../../game_items/equipment/helmet/HeavyHelmet.js');
const HeavyTorsoe = require('../../game_items/equipment/torsoe/HeavyTorsoe.js');
const HeavyBoots = require('../../game_items/equipment/boots/HeavyBoots.js');
const Staff = require('../../game_items/equipment/weapon/Staff.js');

module.exports = {
  handle: 'dreamsmith',
  getAbilityTrees: () => ([
    ArmorUse,
    Illusion,
    Spirit,
    StandardAbilityTree,
  ]),
  getBaseAttributes: () => ({
    learning: 7,
    perception: 7,
    mana: 7,
    toughness: 8,
    strength: 7,
    willpower: 8,
    dexterity: 6,
  }),
  getDefaultAIConfig: () => (['support', 'tank', 'interference', 'dps_close', 'dps_ranged']),
  getStarterEquipment: () => ({
    helmet: ItemGenerator.getRandomItem(HeavyHelmet, 0, 0.1, true),
    torsoe: ItemGenerator.getRandomItem(HeavyTorsoe, 0, 0.1, true),
    boots: ItemGenerator.getRandomItem(HeavyBoots, 0, 0.1, true),
    weapon: ItemGenerator.getRandomItem(Staff, 0, 0.1, true),
  }),
};
